import { User } from '../models/User'
import { adminRoles, enterpriseAdminRoles, ownerRoles } from '../views/ManageTeam/InviteRoleGroups'
import { env } from './util'

export const isAdmin = (user?: User | null) => user?.roles.some((role) => role.id === adminRoles[env]) ?? false

export const isOwner = (user?: User | null) => user?.roles.some((role) => role.id === ownerRoles[env]) ?? false

export const isEnterpriseUser = (user?: User | null) => user?.roles.some((role) => role.id === enterpriseAdminRoles[env]) ?? false

export const isAdminOrEnterpriseAdmin = (user?: User | null) => isAdmin(user) || isEnterpriseUser(user)
